/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { view } from 'react-easy-state'
import { useTranslation } from 'react-i18next'
import policyStore from '../../core/stores/Viriyah/policyStore'
import userStore from '../../core/stores/Viriyah/userStore'

interface policyForm {
  polRenewalBtnStatus: boolean
  claimBtnStatus: boolean
  copyPolBtnStatus: boolean
  descriptionStatus1: boolean
  descriptionStatus2: boolean
  descriptionStatus3: boolean
}

interface renewalMotor {
  show: boolean
}

let firstTimeUse = false

export default view(() => {
  const { t } = useTranslation()

  const [policyForm, setPolicyForm] = React.useState<policyForm>({
    polRenewalBtnStatus: false,
    claimBtnStatus: false,
    copyPolBtnStatus: false,
    descriptionStatus1: false,
    descriptionStatus2: false,
    descriptionStatus3: false
  })

  const [renewalMotor, setRenewalMotor] = React.useState<renewalMotor>({
    show: false
  })

  React.useEffect(() => {
    async function getPolicyFromLineId() {
      try {
        const url = window.location.href
        console.log('url: ', url)
        const urlParams = new URLSearchParams(url)
        const polIdSelected = urlParams.get('pol_id')

        if (!polIdSelected || firstTimeUse) {
          return
        }
        firstTimeUse = true
        policyStore.setPolIdSelected(polIdSelected)
        console.log(policyStore.polIdSelected)

        console.log('getPolicyFromLineId')
        const pathName = 'getPolicyFromLineId'
        const payload = {
          userId: userStore.userId,
          // "userId": "Uba337dd788a54f14cc9dab45611271ad",
          pol_id: policyStore.polIdSelected
        }

        window.bizlink
          .trigger('POST', {
            payload,
            pathName
          })
          .then((response: any) => {
            console.log('getPolicyFromLineId response : ', response)
            if (!response.error) {
              console.log('getPolicyFromLineId success!!!')

              const length = response.policy.length

              for (let i = 0; i < length; i++) {
                if (policyStore.polIdSelected === response.policy[i].pol_id) {
                  const custId: string = response.cust_nat_id
                  const email: string = response.register_info.email ? response.register_info.email : ''
                  const mobile: string = response.register_info.mobileNo ? response.register_info.mobileNo : ''
                  policyStore.setInfo(custId, email, mobile)

                  const polName: string = response.policy[i].pol_name
                  const id: string = response.policy[i].pol_id
                  const custName: string = response.cust_first_name + ' ' + response.cust_last_name
                  const plateNo: string = response.policy[i].pol_voluntary_plateno
                    ? response.policy[i].pol_voluntary_plateno
                    : '-'
                  const startDate: string = response.policy[i].pol_start_date
                  const endDate: string = response.policy[i].pol_end_date
                  // ดึงอันไหนมาใช้?
                  const repairType = '-'
                  const status: string = response.policy[i].pol_status_active
                  const paymentTerm: string =
                    response.policy[i].pol_payment_term === '' ? '-' : response.policy[i].pol_payment_term
                  const paymentAmount: number =
                    response.policy[i].pol_payment_amount === '' ? '-' : response.policy[i].pol_payment_amount

                  const cvtStatus = convertStatus(status)
                  const cvtStartDate = convertDate(startDate)
                  const cvtEndDate = convertDate(endDate)

                  const flagRenew: string = response.renewal.flag_renew ? response.renewal.flag_renew : '-'
                  const netVat: number = response.renewal.NetVat ? response.renewal.NetVat : '-'
                  if (flagRenew === 'N' || flagRenew === '') {
                    if (netVat > 0) {
                      setRenewalMotor({ show: true })
                    }
                  }

                  const polType: string = response.policy[i].pol_type
                  if (polType === 'MV') {
                    policyStore.setMotor(
                      polName,
                      id,
                      custName,
                      plateNo,
                      cvtStartDate,
                      cvtEndDate,
                      repairType,
                      cvtStatus
                    )
                    policyStore.setPolicyType(polType)
                    const numberExpDate: number = calNumberOfDays(endDate)
                    console.log(numberExpDate)

                    setPolicyFormMotor(numberExpDate, renewalMotor.show, polType, cvtStatus)
                  } else if (polType === 'MC') {
                    policyStore.setMotor(
                      polName,
                      id,
                      custName,
                      plateNo,
                      cvtStartDate,
                      cvtEndDate,
                      repairType,
                      cvtStatus
                    )
                    policyStore.setPolicyType(polType)
                    const numberExpDate: number = calNumberOfDays(endDate)
                    console.log(numberExpDate)

                    setPolicyFormMotor(numberExpDate, renewalMotor.show, polType, cvtStatus)
                  } else if (polType === 'AH') {
                    policyStore.setAnH(
                      polName,
                      id,
                      custName,
                      cvtStartDate,
                      cvtEndDate,
                      cvtStatus,
                      paymentTerm,
                      paymentAmount
                    )
                    policyStore.setPolicyType(polType)
                    const numberExpDate: number = calNumberOfDays(endDate)
                    console.log(numberExpDate)

                    setPolicyFormAnH(numberExpDate, cvtStatus)
                  } else {
                    console.log('pol_type not both MV, MC, AH.')
                  }
                }
              }
            } else {
              console.log('myPolicy not success!!!')
            }
          })
          .catch(err => {
            console.log('error', pathName, 'with', err.message)
          })
      } catch (e) {
        console.log('ERROR : ' + e)
      }
    }

    getPolicyFromLineId()
  }, [])

  const convertStatus = (e: string) => {
    if (e === 'A') {
      return 'Active'
    } else if (e === 'C') {
      return 'Cancel'
    } else if (e === 'E') {
      return 'Expire'
    } else if (e === 'G') {
      return 'Grace period'
    }
  }

  const convertDate = (e: string) => {
    const date = e.substr(0, 10).replace(/-/g, '/')
    const BEyear = parseInt(date.substr(6, 4)) + 543
    const dayMonth = date.substr(0, 6)
    return dayMonth + String(BEyear)
  }

  const calNumberOfDays = (e: string) => {
    const splitDateTime = e.split(' ')
    const splitDate = `${splitDateTime[0]}`.split('-')
    const formatDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
    const formatDateTime = `${formatDate} ${splitDateTime[1]}`
    const endDate = new Date(formatDateTime.replace(' ', 'T') + 'Z')
    const presentDate = new Date()

    const oneDay = 1000 * 60 * 60 * 24
    const countNumberExpDate = (endDate.getTime() - presentDate.getTime()) / oneDay

    return countNumberExpDate
  }

  const setPolicyFormMotor = (exp: number, flagRenew: boolean, polType: string, polStatus: string | undefined) => {
    if (exp > 60) {
      console.log('Motor เคส 1 : ก่อนวันหมดอายุมากว่า 60 วัน')
      setPolicyForm({
        polRenewalBtnStatus: false,
        claimBtnStatus: true,
        copyPolBtnStatus: polStatus == 'Active',
        descriptionStatus1: false,
        descriptionStatus2: false,
        descriptionStatus3: false
      })
    } else if (exp >= 0 && exp <= 60) {
      console.log('Motor เคส 2 : ก่อนวันหมดอายุภายใน 60 วัน')
      if (flagRenew) {
        setPolicyForm({
          polRenewalBtnStatus: true,
          claimBtnStatus: true,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: true,
          descriptionStatus2: false,
          descriptionStatus3: false
        })
      } else {
        setPolicyForm({
          polRenewalBtnStatus: false,
          claimBtnStatus: true,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: true,
          descriptionStatus2: false,
          descriptionStatus3: false
        })
      }
    } else if (exp >= -180 && exp < 0) {
      console.log('Motor เคส 3 : เลยวันหมดอายุแล้ว แต่ไม่เกิน 180 วัน')
      if (flagRenew) {
        setPolicyForm({
          polRenewalBtnStatus: true,
          claimBtnStatus: false,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: false,
          descriptionStatus2: true,
          descriptionStatus3: false
        })
      } else {
        setPolicyForm({
          polRenewalBtnStatus: false,
          claimBtnStatus: false,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: false,
          descriptionStatus2: true,
          descriptionStatus3: false
        })
      }
    } else if (exp < -180) {
      console.log('Motor เคส 4 : เลยวันหมดอายุเกิน 180 วัน')
      if (polType === 'MV') {
        setPolicyForm({
          polRenewalBtnStatus: false,
          claimBtnStatus: false,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: false,
          descriptionStatus2: false,
          descriptionStatus3: true
        })
      } else {
        setPolicyForm({
          polRenewalBtnStatus: false,
          claimBtnStatus: false,
          copyPolBtnStatus: polStatus == 'Active',
          descriptionStatus1: false,
          descriptionStatus2: false,
          descriptionStatus3: false
        })
      }
    }
  }

  const setPolicyFormAnH = (exp: number, polStatus: string | undefined) => {
    if (exp > 30) {
      console.log('AnH เคส 1 : ยังไม่ใกล้หมดอายุ')
      setPolicyForm({
        polRenewalBtnStatus: false,
        claimBtnStatus: true,
        copyPolBtnStatus: polStatus == 'Active',
        descriptionStatus1: false,
        descriptionStatus2: false,
        descriptionStatus3: false
      })
    } else if (exp >= 0 && exp <= 30) {
      console.log('AnH เคส 2 : ก่อนวันหมดอายุภายใน 30 วัน')
      setPolicyForm({
        polRenewalBtnStatus: true,
        claimBtnStatus: true,
        copyPolBtnStatus: polStatus == 'Active',
        descriptionStatus1: true,
        descriptionStatus2: false,
        descriptionStatus3: false
      })
    } else if (exp >= -30 && exp < 0) {
      console.log('AnH เคส 3 : หลังวันหมดอายุ 30 วัน')
      setPolicyForm({
        polRenewalBtnStatus: true,
        claimBtnStatus: false,
        copyPolBtnStatus: polStatus == 'Active',
        descriptionStatus1: false,
        descriptionStatus2: true,
        descriptionStatus3: false
      })
    } else if (exp < -30) {
      console.log('AnH เคส 4 : เลยวันหมดอายุมากกว่า 30 วัน')
      setPolicyForm({
        polRenewalBtnStatus: false,
        claimBtnStatus: false,
        copyPolBtnStatus: polStatus == 'Active',
        descriptionStatus1: false,
        descriptionStatus2: false,
        descriptionStatus3: false
      })
    }
  }

  const renewalWebsite = () => {
    const policyType = '1'
    const policyNo = policyStore.polIdSelected
    const insuredName = policyStore.custName
    const insuredIdentityType = 'c'
    const insuredIdentityCard = policyStore.custId
    const insuredEmail = ''
    const insuredMobile = ''
    const insuredPlateNo = policyStore.plateNo
    const paymentAmount = policyStore.paymentAmount

    const url =
      'https://uat.viriyah.com/renew/public/payment?traffic=line&policyType=' +
      policyType +
      '&policyNo=' +
      policyNo +
      '&insuredName=' +
      insuredName +
      '&insuredIdentityType=' +
      insuredIdentityType +
      '&insuredIdentityCard=' +
      insuredIdentityCard +
      '&insuredEmail=' +
      insuredEmail +
      '&insuredMobile=' +
      insuredMobile +
      '&insuredPlateNo=' +
      insuredPlateNo +
      '&paymentAmount=' +
      paymentAmount

    console.log(url)

    window.open(url)
  }

  const renewalCallEmail = () => {
    const modal = document.getElementById('renewalModal')
    const span = document.getElementById('renewalClose')
    const call = document.getElementById('renewalCall')
    const email = document.getElementById('renewalEmail')

    modal.style.display = 'block'

    span.onclick = function () {
      modal.style.display = 'none'
    }

    call.onclick = function () {
      modal.style.display = 'none'
      window.open('tel:024228899')
    }

    email.onclick = function () {
      modal.style.display = 'none'
      window.open('mailto:AH_Renew@viriyah.co.th')
    }

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none'
      }
    }
  }

  const claimMotor = () => {
    window.location.href = 'tel:1557'
  }

  const claimAnH = () => {
    const modal = document.getElementById('claimModal')
    const span = document.getElementById('claimClose')
    const call = document.getElementById('claimCall')
    const email = document.getElementById('claimEmail')

    modal.style.display = 'block'

    span.onclick = function () {
      modal.style.display = 'none'
    }

    call.onclick = function () {
      modal.style.display = 'none'
      window.open('tel:024228888')
    }

    email.onclick = function () {
      modal.style.display = 'none'
      window.open('mailto:AH_CS@VIRIYAH.CO.TH')
    }

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none'
      }
    }
  }

  const requestDocument = () => {
    const pathName = 'getDocument'
    const payload = {
      userId: userStore.userId,
      // "userId": "Uba337dd788a54f14cc9dab45611271ad",
      pol_id: policyStore.polIdSelected,
      req_type: '',
      pol_type: policyStore.polType
    }
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('response.status: ', response.status)
        // response = {
        //   status: 'success',
        //   url: 'https://uat-api.viriyah.co.th/uat/gw/apigw/api/ecm/alfreco/file-hash/6D7256624A6C2B74634C7A5A306C46594A436E625A347650564878636F4872326963332B352F53514356546955765876427A4747426A2F7448504B726F547363'
        // }
        if (response.status == 'success') {
          const url_map = JSON.parse(response.url)
          if (url_map[policyStore.polIdSelected]) {
            window.open(url_map[policyStore.polIdSelected])
          } else {
            noDocument()
          }
        } else {
          noDocument()
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const noDocument = () => {
    const modal = document.getElementById('noDocModal')
    const span = document.getElementById('noDocClose')
    const button = document.getElementById('ok')

    modal.style.display = 'block'

    span.onclick = function () {
      modal.style.display = 'none'
    }

    button.onclick = function () {
      modal.style.display = 'none'
    }

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none'
      }
    }
  }

  if (policyStore.polType === 'MV' || policyStore.polType === 'MC') {
    // ประกันภัยรถยนต์

    return (
      <>
        <section className="my-policy pt-16">
          <div className="">
            <p id="policy-name">{policyStore.polName}</p>
            <p id="policy-type">{t('viriyah.my-policy-page.motor.title-pol-type')}</p>

            <div className="form-box">
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-id')}</span>
                <span className="value">{policyStore.id}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-cust-name')}</span>
                <span className="value">{policyStore.custName}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-plateno')}</span>
                <span className="value">{policyStore.plateNo}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-start-date')}</span>
                <span className="value">{policyStore.startDate}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-end-date')}</span>
                <span className="value">{policyStore.endDate}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-repair-type')}</span>
                <span className="value">{policyStore.repairType}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-status')}</span>
                <span className="value">{policyStore.status}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.motor.label-pol-due-renew')}</span>
                <span className="value">{policyStore.endDate}</span>
              </p>
            </div>
          </div>

          <div className="bottom-section ">
            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.polRenewalBtnStatus ? t('viriyah.my-policy-page.motor.button-pol-renewal') : null
              }}
              onClick={renewalWebsite}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.claimBtnStatus ? t('viriyah.my-policy-page.motor.button-claim') : null
              }}
              onClick={claimMotor}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.copyPolBtnStatus ? t('viriyah.my-policy-page.motor.button-copy-pol') : null
              }}
              onClick={requestDocument}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus1 ? t('viriyah.my-policy-page.motor.description_1') : null
              }}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus2 ? t('viriyah.my-policy-page.motor.description_2') : null
              }}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus3 ? t('viriyah.my-policy-page.motor.description_3') : null
              }}
            />
          </div>

          <div id="noDocModal" className="modal">
            <div className="modal-content">
              <span id="noDocClose" className="close">
                &times;
              </span>
              <p>ไม่มีเอกสารที่คุณต้องการดาวน์โหลด</p>
              <button id="ok" className="modal-btn">
                ตกลง
              </button>
            </div>
          </div>
        </section>
      </>
    )
  } else if (policyStore.polType === 'AH') {
    // ประกันภัยอุบัติเหตุและสุขภาพ

    return (
      <>
        <section className="my-policy pt-16">
          <div className="">
            <p id="policy-name">{policyStore.polName}</p>
            <p id="policy-type">{t('viriyah.my-policy-page.AnH.title-pol-type')}</p>

            <div className="form-box">
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-id')}</span>
                <span className="value">{policyStore.id}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-cust-name')}</span>
                <span className="value">{policyStore.custName}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-start-date')}</span>
                <span className="value">{policyStore.startDate}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-end-date')}</span>
                <span className="value">{policyStore.endDate}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-status')}</span>
                <span className="value">{policyStore.status}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-payment-term')}</span>
                <span className="value">{policyStore.paymentTerm}</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-payment-amount')}</span>
                <span className="value">{policyStore.paymentAmount} บาท</span>
              </p>
              <p id="line">
                <span className="label-text">{t('viriyah.my-policy-page.AnH.label-pol-due-renew')}</span>
                <span className="value">{policyStore.endDate}</span>
              </p>
            </div>
          </div>

          <div className="bottom-section">
            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.polRenewalBtnStatus ? t('viriyah.my-policy-page.AnH.button-pol-renewal') : null
              }}
              onClick={renewalCallEmail}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.claimBtnStatus ? t('viriyah.my-policy-page.AnH.button-claim') : null
              }}
              onClick={claimAnH}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.copyPolBtnStatus ? t('viriyah.my-policy-page.AnH.button-copy-pol') : null
              }}
              onClick={requestDocument}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus1 ? t('viriyah.my-policy-page.AnH.description_1') : null
              }}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus2 ? t('viriyah.my-policy-page.AnH.description_2') : null
              }}
            />

            <div
              dangerouslySetInnerHTML={{
                __html: policyForm.descriptionStatus3 ? t('viriyah.my-policy-page.AnH.description_3') : null
              }}
            />
          </div>

          <div id="renewalModal" className="modal">
            <div className="modal-content">
              <span id="renewalClose" className="close">
                &times;
              </span>
              <p>
                หากคุณต้องการต่ออายุกรมธรรม์
                <br />
                กรุณาติดต่อแผนกต่ออายุกรมธรรม์ค่ะ
              </p>
              <button id="renewalCall" className="modal-btn">
                <img
                  className="icon"
                  src="https://upload.convolab.ai/viriyah-dev%2Fdfe01f9d-ec25-4fe0-97fe-b538d1780426.png"
                />
                แผนกต่ออายุกรมธรรม์
              </button>
              <button id="renewalEmail" className="modal-btn">
                <img
                  className="icon"
                  src="https://upload.convolab.ai/viriyah-dev%2F3d715d83-bc2a-43a8-9c7b-adc5aa6f5ba4.png"
                />
                Email
              </button>
            </div>
          </div>

          <div id="claimModal" className="modal">
            <div className="modal-content">
              <span id="claimClose" className="close">
                &times;
              </span>
              <p>
                หากคุณต้องการแจ้งเคลม
                <br />
                กรุณาติดต่อแผนกแจ้งเคลมค่ะ
              </p>
              <button id="claimCall" className="modal-btn">
                <img
                  className="icon"
                  src="https://upload.convolab.ai/viriyah-dev%2Fdfe01f9d-ec25-4fe0-97fe-b538d1780426.png"
                />
                แผนกแจ้งเคลม
              </button>
              <button id="claimEmail" className="modal-btn">
                <img
                  className="icon"
                  src="https://upload.convolab.ai/viriyah-dev%2F3d715d83-bc2a-43a8-9c7b-adc5aa6f5ba4.png"
                />
                Email
              </button>
            </div>
          </div>

          <div id="noDocModal" className="modal">
            <div className="modal-content">
              <span id="noDocClose" className="close">
                &times;
              </span>
              <p>ไม่มีเอกสารที่คุณต้องการดาวน์โหลด</p>
              <button id="ok" className="modal-btn">
                ตกลง
              </button>
            </div>
          </div>
        </section>
      </>
    )
  } else {
    // ไม่ใช่ทั้งหมด

    return (
      <>
        <section className="my-policy pt-16">
          <div className="">
            <p id="policy-name">อยู่ระหว่างการดึงข้อมูล...</p>
          </div>
        </section>
      </>
    )
  }
})
